export default "__VITE_ASSET__$7wWfHx___"